var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-progress-linear',{attrs:{"active":_vm.loading,"indeterminate":_vm.loading,"absolute":"","top":""}}),_c('v-main',{staticClass:"pb-13"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }